<div nxLayout="grid maxwidth" class="new-insured-trip">
    <div nxRow>
        <div nxCol="12">
            <nx-card>
                <nx-card-header>
                    <h3 nxHeadline="subsection-medium" translate class="title">
                        policy.insured-trips.new.title</h3>
                </nx-card-header>
                <div class="trip-content">
                    <div nxRow>
                        <div nxCol="12">
                            <form [formGroup]="formNewInsuredTrip" #ngForm="ngForm" (submit)="submit($event)">
                                <div nxRow class="mt-34">
                                    <div nxCol="12,6">
                                        <nx-formfield label="{{ 'policy.insured-trips.data.module' | translate }}">
                                            <nx-dropdown formControlName="module">
                                                <ng-template ngFor let-stav="$implicit"
                                                    [ngForOf]="moduleValues|keyvalue">
                                                    <nx-dropdown-item value="{{stav.key}}">
                                                        {{stav.value}}</nx-dropdown-item>
                                                </ng-template>
                                            </nx-dropdown>
                                        </nx-formfield>
                                    </div>
                                    <div nxCol="12,6">
                                        <nx-formfield
                                            label="{{ 'policy.insured-trips.data.start-insurance-date' | translate }}">
                                            <input nxDatefield nxInput [datepicker]="dateDatepickerStart" (dateChange)="changedDateStart($event)"
                                                [datefieldFilter]="filterDateBegin" formControlName="dateBegin"
                                                [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                                            <nx-datepicker-toggle [for]="dateDatepickerStart" nxFormfieldSuffix>
                                            </nx-datepicker-toggle>
                                            <nx-datepicker #dateDatepickerStart></nx-datepicker>
                                        </nx-formfield>
                                    </div>
                                </div>
                                <div nxRow class="mt-16" nxRowAlignItems="end">
                                    <div nxCol="12,6">
                                        <nx-radio-group formControlName="zone">
                                            <div class="horizontal-items">
                                                <nx-label class="nx-margin-bottom-m">{{
                          'policy.insured-trips.data.country-zone' | translate
                          }}
                                                </nx-label>
                                                <nx-radio value="A" class="nx-margin-bottom-m">
                                                    {{ 'policy.insured-trips.data.zone-a' | translate }}
                                                </nx-radio>
                                                <nx-radio value="B" class="nx-margin-left-s nx-margin-bottom-m">
                                                    {{ 'policy.insured-trips.data.zone-b' | translate }}
                                                </nx-radio>
                                            </div>
                                        </nx-radio-group>
                                    </div>
                                    <div nxCol="12,6">
                                        <nx-formfield
                                            label="{{ 'policy.insured-trips.data.end-insurance-date' | translate }}">
                                            <input nxDatefield nxInput [datepicker]="dateDatepickerEnd"
                                                [datefieldFilter]="filterDateEnd" formControlName="dateEnd"
                                                [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                                            <nx-datepicker-toggle [for]="dateDatepickerEnd" nxFormfieldSuffix>
                                            </nx-datepicker-toggle>
                                            <nx-datepicker #dateDatepickerEnd [startAt]="dateEndStart"></nx-datepicker>
                                        </nx-formfield>
                                    </div>
                                </div>

                                <div nxRow *ngIf="tariff&&rate">
                                    <div nxCol="12" class="tarif-rate">
                                        <span class="nx-font-weight-light">{{
                      'policy.insured-trips.data.tariff' | translate }} <span
                                                class="nx-font-weight-semibold">{{tariff}}</span></span>
                                        <span class="nx-font-weight-light">{{
                      'policy.insured-trips.data.charge' | translate }} <span
                                                class="nx-font-weight-semibold">{{rate | currencyFormat}}</span></span>
                                    </div>
                                </div>

                                <div nxRow>
                                    <div nxCol="12,6">
                                        <nx-formfield
                                            label="{{ 'policy.insured-trips.data.add-employee' | translate }}">
                                            <input nxInput type="text" nxAutocompleteDebounce='0'
                                                [nxAutocomplete]='employeesAutocomplete' #employeesInput />
                                        </nx-formfield>
                                        <nx-autocomplete #employeesAutocomplete='nxAutocomplete'
                                            (optionSelected)="selectEmployee($event)">
                                            <nx-autocomplete-option
                                                *ngFor='let item of getEmployees(employeesInput.value)'
                                                [value]='item | employeeFormat'>
                                                {{item | employeeFormat }}
                                            </nx-autocomplete-option>
                                        </nx-autocomplete>
                                    </div>
                                </div>

                                <div nxRow>
                                    <div nxCol="12" formArrayName="employees">
                                        <ng-container
                                            *ngFor="let selectedEmployee of formNewInsuredTrip.get('employees')['controls'];let i = index">
                                            <div nxRow [formGroupName]="i">
                                                <div nxCol="9" class="employee">
                                                    <cpc-icon icon='trash-o' color="#007ab3" style="font-size: 20px"
                                                        (click)="deselectEmployee(i)"></cpc-icon>
                                                    <nx-formfield>
                                                        <input nxInput type="text" formControlName="employee"
                                                            value="{{ selectedEmployee.value.employee | employeeFormat }}">
                                                    </nx-formfield>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div nxCol="12"
                                        *ngIf="ngForm.submitted && formNewInsuredTrip.get('employees')['controls'].length==0">
                                        <nx-error appearance="text">
                                            <span translate>
                                                policy.insured-trips.empty-employees
                                            </span>
                                        </nx-error>
                                    </div>
                                </div>

                                <div nxRow *ngIf="premium">
                                    <div nxCol="12" class="insurance-price">
                                        <span class="nx-font-weight-light heading">{{
                      'policy.insured-trips.data.premium' | translate }}</span>
                                        <span class="nx-font-weight-semibold">{{ premium | currencyFormat
                      }}</span>
                                    </div>
                                </div>

                                <div nxRow class="nx-margin-top-m" *ngIf="this.showHasTravel">
                                    <div nxCol="12">
                                        <h3 nxHeadline="subsection-medium" translate class="title">
                                            policy.insured-trips.employee-has-travel</h3>
                                        <div *ngFor="let item of this.hasTravel|keyvalue">
                                            <h3>{{ formatKeyName(item.key) }}</h3>
                                            <p *ngFor="let itemList of item.value.list">
                                                <nx-link>
                                                    <a
                                                        href="{{ getHasTravelLink(itemList.policyNumber) }}">{{itemList.policyNumber}}</a>
                                                </nx-link> - {{ itemList.dateBegin|dateFormat }}
                                                {{ itemList.dateEnd|dateFormat }}
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div nxRow>
                                    <div nxCol="12" class="form-buttons">
                                        <a routerLink="../">
                                            <button nxButton="secondary normal" type="button">
                                                <span translate>policy.insured-trips.back-btn</span>
                                            </button>
                                        </a>
                                        <button nxButton="primary normal" type="submit">
                                            <span translate>policy.insured-trips.new.submit-btn</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </nx-card>
        </div>
    </div>
</div>